import clsx from 'clsx'
import styles from './DialogDescription.module.scss'
import React, {ReactNode} from 'react'

interface DialogDescriptionProps {
    className?: string
    children?: ReactNode
}

export function DialogDescription({
    className,
    children,
}: DialogDescriptionProps) {
    return (
        <div className={clsx(styles.description, className)}>
            {children}
        </div>
    )
}
